import React, { useEffect } from "react";
import moment from "moment";
import { ChallengeInterface } from "src/store/mine_craft/challengesSlice";

import { Button, DatePicker, Form, Input, Radio } from "antd";
import FileDropzone from "src/componets/FileDropzone";
import Tags from 'src/componets/Form/Tags';

const { RangePicker } = DatePicker;

window.moment = moment;

interface propsInterface {
  params?: ChallengeInterface | undefined;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  const ranges: any = {
    Today: [
      moment().utc().startOf('day'),
      moment().utc().endOf('day')
    ],
    'This Week': [
      moment().utc().startOf('week'),
      moment().utc().endOf('week')
    ],
    'Next Week': [
      moment().utc().add(1, 'weeks').startOf('week'),
      moment().utc().add(1, 'weeks').endOf('week')
    ],
  }

  const rangeConfig = {
    rules: [{ type: 'array' as const, required: true, message: 'Please select time!' }],
  };

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
      </div>

      <Form.Item name='title' label="Title">
        <Input placeholder='Title' />
      </Form.Item>

      <Form.Item name='subtitle' label="Subtitle">
        <Input placeholder='Subtitle' />
      </Form.Item>

      <Form.Item name="range" label='Date' {...rangeConfig}>
        <RangePicker ranges={ranges} />
      </Form.Item>

      <Tags
        form={form}
        name='filters'
        label='Filters'
      />

      <Form.Item label="Dificulity" name='difficulty'>
        <Radio.Group optionType="button" buttonStyle='solid'>
          <Radio value='easy'>Easy</Radio>
          <Radio value='medium'>Medium</Radio>
          <Radio value='hard'>Hard</Radio>
          <Radio value='expert'>Expert</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item label="Type" name='add_type'>
        <Radio.Group>
          <Radio value='addon'>Addon</Radio>
          <Radio value='skin'>Skin</Radio>
          <Radio value='world'>World</Radio>
          <Radio value='skin_pack'>Skin Pack</Radio>
          <Radio value='post'>Post</Radio>
          <Radio value='structure'>Structure</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item name='description' label="Description">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item name='rules' label="Rules">
        <Input.TextArea rows={4} />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
